import React, { Component } from 'react';
import { Switch, Route, Router } from 'react-router-dom';
import HeaderPage from '../projectmgmt/header/Header';
import NlpLeftPanel from './NlpLeftPanel';
class NlpMainPage extends Component {
  render() {
    return (
      <div style={{ backgroundColor: '#F9F9FB' }}>
        <div id="navBar">
          <HeaderPage />
        </div>


        <div className="content-wrapper" id="leftPanel" >
              <Route path='/cloud-nlp' component={NlpLeftPanel}></Route>
        </div>


      </div>




    );
  }
}

export default NlpMainPage;


// WEBPACK FOOTER //
// ./src/nlpUi/NlpMainPage.js